import PropTypes from 'prop-types'
import { Select, SIZE, TYPE } from 'baseui/select'
import { mergeOverrides } from 'baseui'
import { FloatingLabel, SDSelectOverrides, SDSelectPulseOverrides } from './styled-components'
import { t } from 'i18next'
import { RelativeContainer } from '@/shared/theme/styled-components'
import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import SDFieldLabel from '../SDFieldLabel/SDFieldLabel'
import { PulseFieldContainer } from '../SDFieldLabel/styled-components'

const SDSelect = ({
  label,
  optionsList,
  selectedValue,
  onChangeHandler,
  placeholder = '',
  clearable = false,
  type = TYPE.select,
  disabled = false,
  hasError = false,
  missing = false,
  overrides,
  newTranslations,
  translationsPath,
  ...rest
}) => {
  const isPulse = usePulseScope()
  const options = []
  const selected = []

  if (optionsList) {
    for (const [id, name] of Object.entries(optionsList)) {
      const label = newTranslations ? t(translationsPath + name) : name
      const optionId = newTranslations ? name : id
      const data = { label, id: optionId }

      options.push(data)

      if (optionId === selectedValue) {
        selected.push(data)
      }
    }
  }

  const newOverrides = mergeOverrides(isPulse ? SDSelectPulseOverrides(missing) : SDSelectOverrides(), overrides)
  const Container = isPulse ? PulseFieldContainer : RelativeContainer

  return (
    <Container>
      {label && <SDFieldLabel label={label} FloatingLabelComponent={FloatingLabel} />}
      <Select
        disabled={disabled}
        error={hasError}
        options={options}
        clearable={clearable}
        value={selected}
        onChange={onChangeHandler}
        placeholder={placeholder}
        type={type}
        maxDropdownHeight='320px'
        labelKey='label'
        valueKey='label'
        size={SIZE.compact}
        overrides={newOverrides}
        {...rest}
      />
    </Container>
  )
}

SDSelect.propTypes = {
  label: PropTypes.string,
  optionsList: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  selectedValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChangeHandler: PropTypes.func,
  placeholder: PropTypes.string,
  clearable: PropTypes.bool,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  missing: PropTypes.bool,
  overrides: PropTypes.object,
  newTranslations: PropTypes.bool,
  translationsPath: PropTypes.string,
}

export default SDSelect
